module.exports = "pegasus/assets/theme3/google-icon.png";